import type { ReactNode } from 'react'
import { View } from 'react-native'

import { spacing, type TSpace } from './spacer.type'

type TSpacerProps = {
  x?: TSpace
  y?: TSpace
}
export const Spacer = ({ x = 0, y = 0 }: TSpacerProps): ReactNode => (
  <View
    style={{
      width: spacing[x],
      height: spacing[y],
    }}
  />
)
